import { render, staticRenderFns } from "./PFSettlementRejectedList.vue?vue&type=template&id=46fe670c"
import script from "./PFSettlementRejectedList.vue?vue&type=script&lang=js"
export * from "./PFSettlementRejectedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports